export const defaultThreadTitle = 'Unnamed chat';
